/**
 * Sekcje rachunku i ich kolejność.
 *
 * Podział wierszy na sekcje jest **decyzją prezentacyjną frontu** i backend
 * świadomie jej nie wystawia: księga cen zna wyłącznie typ linii kosztowej,
 * a dane osoby, wartości pól niestandardowych i wybory przychodzą osobnymi
 * endpointami. Kolejność sekcji to kolejność wartości tego enuma — od tego,
 * co uczestnik kupił, przez jego dane, po pozycje dopisywane ręcznie.
 *
 * Identyfikator sekcji na ekranie jest prefiksowany osobą (`{personId}:{id}`),
 * bo ekran rezerwacji pokazuje kilka osób naraz.
 */
export enum BillSectionId {
  PACKAGE = 'package',
  PARTICIPANT = 'participant',
  EXTRA_INFO = 'extra-info',
  ACTIVITIES = 'activities',
  TRANSPORT_INSURANCE = 'transport-insurance',
  DISCOUNTS = 'discounts',
  MANUAL_LINES = 'manual-lines',
  CLIENT_CONTACT = 'client-contact',
  BOOKING_ADJUSTMENTS = 'booking-adjustments',
}

export const BILL_SECTION_TITLES: Record<BillSectionId, string> = {
  [BillSectionId.PACKAGE]: 'Pakiet',
  [BillSectionId.PARTICIPANT]: 'Uczestnik',
  [BillSectionId.EXTRA_INFO]: 'Informacje dodatkowe',
  [BillSectionId.ACTIVITIES]: 'Aktywności dodatkowe',
  [BillSectionId.TRANSPORT_INSURANCE]: 'Transport i ubezpieczenie',
  [BillSectionId.DISCOUNTS]: 'Zniżki i korekty',
  [BillSectionId.MANUAL_LINES]: 'Pozycje ręczne',
  [BillSectionId.CLIENT_CONTACT]: 'Dane kontaktowe',
  [BillSectionId.BOOKING_ADJUSTMENTS]: 'Zniżki i korekty rezerwacji',
};

/** Dopiski przy tytule sekcji; `null` znaczy „sekcja mówi sama za siebie”. */
export const BILL_SECTION_HINTS: Partial<Record<BillSectionId, string>> = {
  [BillSectionId.EXTRA_INFO]: 'pola z formularza wyjazdu',
  [BillSectionId.CLIENT_CONTACT]: 'jeden zestaw, jedna pozycja paczki',
  [BillSectionId.BOOKING_ADJUSTMENTS]: 'pozycje bez przypisania do uczestnika',
};
